export { getGoogleLoginCredential, setupGoogleSignin, signOutOfGoogle } from './google';
export { signOutOfNativePlatformModules } from './native';
export { default as signInWithCredential } from './signInWithCredential';
